<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type="primary" v-if="type !== 1" @click="save">保存</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
    <div class="main">
    <el-form :model="form" label-position="right"  class="mainfrom from_input">

          <el-form-item label="表单代号">
            <el-input v-model="form.formcode" :maxlength="30" show-word-limit :disabled="disable"></el-input>
          </el-form-item>

          <el-form-item label="表单名">
            <el-input v-model="form.formname" :maxlength="30" show-word-limit :disabled="disable"></el-input>
          </el-form-item>



          <el-form-item label="表单数据表">
            <el-select v-model="form.formtableid" clearable :disabled="disable">
              <el-option v-for="(table, index) in tableList" :label="table.tablename" :value="table.tableid" :key="index"></el-option>
            </el-select>
          </el-form-item>

    </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "addForm",
    data () {
      return {
        form: this.$route.params.form,
        tableList: [],
        type: this.$route.params.type,
        disable: this.$route.params.type === 1 ? true : false
      }
    },
    created () {
      this.getTable()
    },
    filters: {
    },
    methods: {
      async getTableList () {
        this.list = await request({
          method: 'get',
          url: '/table/getTable',
          params: {}
        })
      },
      async save () {
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'formIndex'})
      }
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 840px;
    }
  }
</style>
